<template>
  <base-section
    id="gallery"
  >
  <v-container>
    <base-section-heading
        title="Gallery"
    >
    <v-dialog
    v-model="selectedOpen"
    :activator="selectedElement"
    >
        <img
            :src="selectedEvent"
        >

    </v-dialog>
    <v-row>
        <v-col
        v-for="(img, n) in images"
        :key="n"
        class="d-flex child-flex"
        cols="4"
        >
        <v-img
            :src="img.pathLong"
            aspect-ratio="1"
            class="grey lighten-2"
            @click="handleEventClickImg($event, img.pathLong)"
        >
            <template v-slot:placeholder>
            <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
            >
                <v-progress-circular
                indeterminate
                color="grey lighten-5"
                ></v-progress-circular>
            </v-row>
            </template>
        </v-img>
        </v-col>
    </v-row>

    </base-section-heading>
  </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Gallery',
    data: () => ({
      isMobile: false,
      overlay: false,
      images: [],
      selectedElement: {},
      selectedEvent: {},
      selectedOpen: false,
    }),
    mounted () {
      this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      this.importAll(require.context('../../social_media/', true, /\.jpg$/));
    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      importAll(r) {
        r.keys().forEach(key => (this.images.push({ pathLong: r(key), pathShort: key })));
      },
      handleEventClickImg(event, img) {
        const open = () => {
            this.selectedEvent = img
            this.selectedElement = event.target
            requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
            //  this.selectedOpen = true
        }

        if (this.selectedOpen) {
            this.selectedOpen = false
            requestAnimationFrame(() => requestAnimationFrame(() => open()))
        } else {
            open()
        }

        event.stopPropagation()
      },
    },
  }
</script>
<style>
.v-btn__content {
  width: 100%;
  white-space: break-spaces;
}
</style>
